import axios from "axios";


//https://localhost:7063;http://localhost:5198;http://10.10.10.112:5568

/*const BASE_URL = __DEV__ 
  ? 'https://localhost:7063/api/'  // Para desenvolvimento, usando IP local ou localhost
  : 'https://localhost:7063/api/';  // Para produção, usando domínio público

  console.log(__DEV__)*/

  //const _URL = __DEV__ ? "http://10.10.10.112:3693/api/" : "https://www.delivery-h.shop.iron.hostazul.com.br/api/";

//const url = "http://192.168.0.106:5568/api/"

var prod = false;

if (process.env.NODE_ENV === 'development') {
  console.log('Rodando em modo desenvolvimento');
  prod = false;
} else if (process.env.NODE_ENV === 'production') {
  console.log('Rodando em modo produção');
  prod = true;
}

const url = prod ? "https://api.assaicartola2.shop/api/" : "http://localhost:5137/api/"
const api = axios.create({
    baseURL: url,
    //timeout: 10000,
    //timeout:   10000,

});

export default api;